import { MenuItem, Select, Typography } from '@mui/material';
import { type BackupVault } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { BackupVaultSelectionDialog } from '@/components/vaults/backupVaultSelectionDialog';
import { VaultTag } from '@/components/vaults/vaultTag';
import { useBackupVaults } from '@/data/vaults/useBackupVaults';

export const BackupVaultTagSelection = ({
  vaultId,
  onUpdate,
  entityName,
  vaultsPredicate,
}: {
  vaultId: string | undefined;
  onUpdate: (vault: BackupVault) => void;
  entityName?: string;
  vaultsPredicate?: (vault: BackupVault) => boolean;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { vaults } = useBackupVaults();
  const vault = vaults.find((v) => v.id === vaultId);
  return (
    <>
      <Select
        sx={{
          '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
          },
          '& .MuiTypography-root': {
            color: 'var(--mui-palette-text-disabled)',
          },
        }}
        data-testid='create-backup-policy-vault-select'
        variant='standard'
        value={vaultId || 0}
        open={false}
        native={false}
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        {(!vaultId || !vault) && (
          <MenuItem value={vaultId || 0}>
            <Typography className='font-medium'>Choose vault</Typography>
          </MenuItem>
        )}

        {vaultId && vault && (
          <MenuItem value={vaultId}>
            <VaultTag vault={vault} sx={{ margin: 0, cursor: 'pointer' }} />
          </MenuItem>
        )}
      </Select>
      <BackupVaultSelectionDialog
        vaultsPredicate={vaultsPredicate}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSelect={(vault) => {
          onUpdate(vault);
          setDialogOpen(false);
        }}
        entityName={entityName}
        selectedVaults={vaultId ? [vaultId] : []}
        isLoading={false}
      />
    </>
  );
};
